module.exports = __webpack_public_path__ + "static/tracer-dao-blue-fca7006d07135e4a90995daadea6b9ca.png";